import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { PayCorrectionExtras } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionOutput';
import { PayCorrectionOutput } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionOutput';

export const PayCorrectionCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'payCorrection',
  outputFileName: 'pay_correction_output.json',
  isDataQueuingAllowed: true,
  outputSchema: PayCorrectionOutput,
  extrasSchema: PayCorrectionExtras,
  resolveFocusArea: () => 'Compensation',
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.643,
    multiplier: 0.01495,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'payCorrection') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: [
        {
          columnHeaderValue: 'Location',
          values: request.inputs.dropdowns.location,
        },
        {
          columnHeaderValue: 'Job Level',
          values: request.inputs.dropdowns.job_level ?? [],
        },
        {
          columnHeaderValue: 'Department',
          values: request.inputs.dropdowns.department,
        },
      ],
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'copilot/pay-correction',
};
